const tableGenerationPrompt = `Generate a 2D array of table cell content and a JavaScript function that transforms each cell into a nested JSON schema with the following structure:

🔤 Text

text.enabled: Boolean — is text used.

text.value.default: String — the cell's text.

text.color.default: Optional text color.

text.size.default : Text font size in number.



🗾 Image

image.enabled: Boolean — is an image used.

image.src.default: Image URL or path.

📝 Input

input.enabled: Boolean — is an input field used. 

input.type: "text", "latex", or "latex-fill-in-blank". compulsary field

input.placeholder: Placeholder string.

input.default: Default value of the input.

input.fill: Background color of the input.

input.fontColor: Color of typed text inside the input

input.singleLine: Boolean — single-line or multiline input.

input.dimensionControl: Object with minWidth and minHeight.

input.dimensionControl.enabled : Boolean - status of enabled/disabled

input.dimensionControl.minWidth: Number - min width of inputs

input.dimensionControl.minHeight: Number - min heights of inputs

input.inputChangeFeedback: Boolean for feedback on input change.

🕽 Dropdown

dropdown.enabled: Boolean — is a dropdown used.

dropdown.options: Array of string options.

dropdown.default: Default selected option.

🎨 Fill Color (Cell Background)

fillColor.enabled: Boolean — is a background color applied.

fillColor.default: Cell background color.

🙈 Hidden

hidden: Boolean — is the cell hidden.

🧭 Alignment

align: One of "LEFT", "RIGHT", or "CENTER" — horizontal alignment.

alignVertical: One of "TOP", "CENTER", or "BOTTOM" — vertical alignment.

⚙️ Structure Notes:

Each cell can include all main objects (text, image, input, dropdown, fillColor, hidden).

⚙️ Output Instructions

By default, output only:

The 2D content array.

The function to convert it into the above schema.

Accompnying messages

Do not output the final schema unless explicitly asked.

If content is ambiguous, use a safe default or ask for clarification.`;

// Defining the response format structure at module level
const responseFormatKeys = {
    data: "<your 2D array JSON data structure>",
    text: "<your accompanying text explanation, This should not contain any functions or unnecessary data structures, just an explaination text>",
    function:
        "<any accompanying javascript code needed to convert the data into required format. Make sure the function is valid and parsable. Make sure the function is not returning a single array. It should only return either a 2d array or a 3d array. Also no console logs in the function.>",
    process_text:
        "<Your thought process while coming up with the solution, thinking process>",
};

// Template for the response format
const responseFormatTemplate = {
    format: responseFormatKeys,
    validityNote: "Make sure that the JSON is valid and parsable.",
};

const responseValidationPrompt = `You are a helpful assistant that validates the response from the user.
  You will be given a response from the user and you will need to validate it.
  You will need to check if the response is valid and if it is not, you will need to return the error message.
  You will need to check if the response is valid and if it is not, you will need to return the error message.

  return this schema in JSON format:
  {
    "valid": true,
    "error": ""
  } or {
    "valid": false,
    "error": "The response is not valid"
  }

  Here is core prompt:
  ${tableGenerationPrompt}

  Use the above prompt to construct a step by step reasoning process to determine if the shcema and function are valid.
  
  ALWAYS ENSURE THAT THE FUNCTION RETURNS A 2D OR A 3D ARRAY.
  `;

export {
    tableGenerationPrompt,
    responseFormatKeys,
    responseFormatTemplate,
    responseValidationPrompt,
};
